import React from 'react'
import PropTypes from 'prop-types'
import { useTranslation } from 'react-i18next'

import PrimaryButton from './PrimaryButton'
import CleanButton from './CleanButton'

const SUPPORT_LINK = 'https://4kst.tomticket.com/'

function SupportButton({ classes, cleanButton, ...props }) {
  const { t } = useTranslation()
  let ButtonComp = cleanButton ? CleanButton : PrimaryButton

  return (
    <ButtonComp onClick={() => window.open(SUPPORT_LINK)} {...props}>
      {t('default.button.support')}
    </ButtonComp>
  )
}

SupportButton.propTypes = {
  cleanButton: PropTypes.bool
}

SupportButton.defaultProps = {
  cleanButton: false
}

export default SupportButton